(function () {
    'use strict';

    angular
        .module('app')
        .directive('alert', alertDirective);

    alertDirective.$inject = ['helpers', '$timeout',];

    function alertDirective(helpers, $timeout) {
        var directive = {
            restrict: 'EA',
            link: link,
        };

        function link(scope, element) {

            scope.closeAlert = function () {
                element.remove();
                scope.$destroy();
            };
            element.attr('id', scope.name);
            element.find('form')
                .on('submit', function (ev) {
                    if ('function' === typeof scope.submit) {
                        var formData = new FormData(ev.target);
                        scope.submit(formData);
                    }

                    scope.closeAlert();
                });

            $timeout(function() {

                /* Starts the transition to fly in */
                scope.showAlert = true;
            }, 1);

            element.on('click', function (ev) {
                if (ev.target.tagName.toLowerCase() === 'alert' && !scope.modal) {
                    if (typeof scope.no === 'function') {
                        scope.no();
                    }

                    if (typeof scope.cancel === 'function') {
                        scope.cancel();
                    }

                    if (typeof scope.close === 'function') {
                        scope.close();
                    }
                    scope.closeAlert();
                }
            });
        }

        return directive;
    }
})();